<template>
  <v-container fluid class="dashboard-vendas pa-0">
    <DialogDashboards :dialog="dialog" />

    <!-- Loading inicial -->
    <v-row v-if="carregandoInicial" justify="center" align="center" style="min-height: 60vh;">
      <v-col cols="12" class="text-center">
        <v-progress-circular
            :size="80"
            :width="8"
            color="primary"
            indeterminate
        ></v-progress-circular>
        <p class="text-h6 mt-4 grey--text">Carregando dados...</p>
      </v-col>
    </v-row>

    <template v-else>
      <!-- FILTROS -->
      <v-row>
        <v-col cols="12">
          <v-card class="filter-card" elevation="2">
            <v-card-text class="pa-4">
              <v-row align="center" no-gutters>
                <v-col cols="12" sm="5" class="pr-sm-2 pb-3 pb-sm-0">
                  <InputDatePicker
                      v-model="busca.dtinicio"
                      :disabled="carregando"
                      label="Data inicial"
                      outlined
                      dense
                      hide-details
                  />
                </v-col>
                <v-col cols="12" sm="5" class="px-sm-1 pb-3 pb-sm-0">
                  <InputDatePicker
                      v-model="busca.dtfim"
                      :disabled="carregando"
                      label="Data final"
                      outlined
                      dense
                      hide-details
                  />
                </v-col>
                <v-col cols="12" sm="2" class="pl-sm-3">
                  <v-btn
                      :disabled="carregando"
                      :loading="carregando"
                      color="primary"
                      elevation="0"
                      height="40"
                      block
                      @click="carrega"
                  >
                    <v-icon>mdi-magnify</v-icon>
                    <span class="d-none d-lg-inline ml-2">Buscar</span>
                    <span class="d-inline d-sm-none">Filtrar</span>
                  </v-btn>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- SEÇÃO MÁQUINA DE VENDAS -->
      <v-row>
        <v-col cols="12">
          <v-card class="section-card" :style="gradientStyle" dark elevation="4">
            <v-card-title class="section-title px-5 py-4">
              <div class="d-flex align-center">
                <v-icon large class="mr-3">mdi-store</v-icon>
                <div>
                  <h2 class="text-h5 font-weight-bold mb-1">Índices Máquina de Vendas</h2>
                  <p class="text-caption mb-0 white--text" style="opacity: 0.9;">
                    Resultados e metas do departamento
                  </p>
                </div>
              </div>
              <v-spacer />
              <v-tooltip bottom v-if="temDadosMaquinaVendas">
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      color="white"
                      text-color="primary"
                      class="font-weight-bold"
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon small left>mdi-check-circle</v-icon>
                    {{ statusAtualizacao }}
                  </v-chip>
                </template>
                <span>Última atualização: {{ horaUltimaAtualizacao }}</span>
              </v-tooltip>
            </v-card-title>

            <v-divider dark />

            <v-card-text class="pa-4">
              <v-fade-transition mode="out-in">
                <v-row v-if="temDadosMaquinaVendas" class="pa-2">
                  <v-col
                      v-for="(card, index) in cardsMaquinaVendas"
                      :key="card.title"
                      cols="12"
                      sm="6"
                      md="4"
                      lg="3"
                      class="pa-1"
                  >
                    <div class="card-animation" :style="{ animationDelay: `${index * 0.1}s` }">
                      <CardDashboard :loading="carregando" :title="card.title" color="#3D7AA8">
                        {{ card.value }}
                        <MenuInfo v-if="card.info" :texto="card.info" />
                      </CardDashboard>
                    </div>
                  </v-col>
                </v-row>

                <div v-else class="empty-state py-12">
                  <v-icon size="80" color="white" class="mb-4" style="opacity: 0.6;">
                    mdi-information-outline
                  </v-icon>
                  <p class="text-h6 mb-0 white--text">Nenhum dado disponível</p>
                  <p class="text-caption white--text mt-2" style="opacity: 0.8;">
                    Selecione um período e clique em buscar
                  </p>
                </div>
              </v-fade-transition>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- SEÇÃO ECOMMERCE -->
      <v-row>
        <v-col cols="12">
          <v-card class="section-card" :style="gradientStyle" dark elevation="4">
            <v-card-title class="section-title px-5 py-4">
              <div class="d-flex align-center">
                <v-icon large class="mr-3">mdi-cart</v-icon>
                <div>
                  <h2 class="text-h5 font-weight-bold mb-1">Índices Ecommerce</h2>
                  <p class="text-caption mb-0 white--text" style="opacity: 0.9;">
                    Resultados das vendas online
                  </p>
                </div>
              </div>
              <v-spacer />
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-chip
                      color="white"
                      text-color="primary"
                      class="font-weight-bold"
                      v-bind="attrs"
                      v-on="on"
                  >
                    <v-icon small left>mdi-check-circle</v-icon>
                    {{ statusAtualizacao }}
                  </v-chip>
                </template>
                <span>Última atualização: {{ horaUltimaAtualizacao }}</span>
              </v-tooltip>
            </v-card-title>

            <v-divider dark />

            <v-card-text class="pa-4">
              <v-row class="pa-2">
                <v-col
                    v-for="(card, index) in cardsEcommerce"
                    :key="card.title"
                    cols="12"
                    sm="6"
                    md="4"
                    class="pa-1"
                >
                  <div class="card-animation" :style="{ animationDelay: `${index * 0.1}s` }">
                    <CardDashboard :loading="carregando" :title="card.title" color="#3D7AA8">
                      {{ card.value }}
                      <MenuInfo v-if="card.info" :texto="card.info" />
                    </CardDashboard>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- SEÇÃO VENDEDORES -->
      <v-row>
        <v-col cols="12">
          <v-fade-transition>
            <CardsVendedoresMaquinaVendas
                :dataSeries="graficoSeries"
                :labels="labelsNome"
                :carregando="carregando"
                @ver-detalhes="abrirDialog(
                vendedoresMaquinaVendas,
                headerVendedores,
                'Meta x Venda Realizada por Vendedor'
              )"
            />
          </v-fade-transition>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import axios from "axios";
import InputDatePicker from "../Widgets/InputDatePicker";
import CardDashboard from "../Widgets/CardDashboard";
import MenuInfo from "../Widgets/MenuInfo";
import DialogDashboards from "../Widgets/DialogDashboards";
import CardsVendedoresMaquinaVendas from "@/Components/Widgets/CardsVendedoresMaquinaVendas.vue";

// Constantes
const DEPARTAMENTO_MAQUINA_VENDAS = 9;
const DEPARTAMENTO_ECOMMERCE = 10;

export default {
  name: "DashboardVendas",

  components: {
    InputDatePicker,
    CardDashboard,
    MenuInfo,
    DialogDashboards,
    CardsVendedoresMaquinaVendas,
  },

  data: () => ({
    dialog: { status: false, dados: [], header: {}, title: '' },
    carregando: false,
    carregandoInicial: true,
    totaisMaquinaVendas: {},
    totaisEcommerce: {},
    vendedoresMaquinaVendas: [],
    metaEcommerce: 0,
    metaMaquinaVendas: 0,
    dadosMeta: [],
    dadosRealizado: [],
    dadosAtingimento: [],
    labelsNome: [],
    ultimaAtualizacao: null,
    tempoDecorrido: 0,
    intervalTimer: null,
    busca: {
      dtinicio: `${new Date().getFullYear()}-${String(new Date().getMonth() + 1).padStart(2, '0')}-01`,
      dtfim: new Date().toISOString().split("T")[0],
    },
  }),

  computed: {
    ...mapState(["backendUrl", "usuario"]),

    dia() {
      return new Date().toLocaleDateString("pt-BR");
    },

    dataAtual() {
      const options = {
        weekday: 'long',
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      };
      return new Date().toLocaleDateString('pt-BR', options);
    },

    gradientStyle() {
      return { background: 'linear-gradient(135deg, #1E3A5F 0%, #004D66 50%, #003D52 100%)' };
    },

    temDadosMaquinaVendas() {
      return this.totaisMaquinaVendas.MAQUINA_DE_VENDAS !== undefined;
    },

    temDadosGrafico() {
      return this.vendedoresMaquinaVendas.length > 0;
    },

    statusAtualizacao() {
      if (!this.ultimaAtualizacao) return 'Atualizado';

      const minutos = Math.floor(this.tempoDecorrido / 60);
      const horas = Math.floor(minutos / 60);
      const dias = Math.floor(horas / 24);

      if (this.tempoDecorrido < 60) {
        return 'Atualizado agora';
      } else if (minutos < 60) {
        return `${minutos} min atrás`;
      } else if (horas < 24) {
        return `${horas}h atrás`;
      } else {
        return `${dias}d atrás`;
      }
    },

    horaUltimaAtualizacao() {
      if (!this.ultimaAtualizacao) return '--:--';
      return this.ultimaAtualizacao.toLocaleTimeString('pt-BR', {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },

    cardsMaquinaVendas() {
      const mv = this.totaisMaquinaVendas.MAQUINA_DE_VENDAS || {};
      return [
        {
          title: `Venda do dia ${this.dia}`,
          value: this.formatarDinheiro(mv.TOTAL_VENDA_DIARIA)
        },
        {
          title: `Meta do dia ${this.dia} atingida`,
          value: this.formatarPorcentagem(mv.ATINGIMENTO_DIARIO)
        },
        {
          title: `Margem do dia ${this.dia}`,
          value: this.formatarPorcentagem(mv.MARGEM_DIARIA),
          info: 'Margem de venda com base no apoio a decisão'
        },
        {
          title: `Meta do dia ${this.dia}`,
          value: this.formatarDinheiro(0),
        },
        {
          title: 'Venda Acumulada',
          value: this.formatarDinheiro(mv.TOTAL_VENDA_ACUMULADA)
        },
        {
          title: 'Meta Acumulada Atingida',
          value: this.formatarPorcentagem(mv.ATINGIMENTO_ACUMULADO)
        },
        {
          title: 'Margem Acumulada',
          value: this.formatarPorcentagem(mv.MARGEM_ACUMULADA),
          info: 'Margem de venda com base no apoio a decisão'
        },
        {
          title: 'Meta do Mês',
          value: this.formatarDinheiro(this.metaMaquinaVendas)
        },
      ];
    },

    cardsEcommerce() {
      return [
        {
          title: 'Venda Acumulada',
          value: this.formatarDinheiro(this.totaisEcommerce.TOTAL_VENDA)
        },
        {
          title: 'Margem Acumulada',
          value: this.formatarPorcentagem(this.totaisEcommerce.MARGEM),
          info: 'Margem de venda com base no apoio a decisão'
        },
        {
          title: 'Meta do Mês',
          value: this.formatarDinheiro(this.metaEcommerce)
        },
      ];
    },

    graficoSeries() {
      return [
        { name: 'Meta', type: 'column', data: this.dadosMeta },
        { name: 'Realizado', type: 'column', data: this.dadosRealizado },
        { name: 'Atingido', type: 'line', data: this.dadosAtingimento }
      ];
    },

    headerVendedores() {
      return {
        ID: { nome: "ID", tipo: "texto" },
        NOME: { nome: "Vendedor", tipo: "texto" },
        META: { nome: "Meta", tipo: "dinheiro" },
        TOTALVENDA: { nome: "Realizado", tipo: "dinheiro" },
        ATINGIMENTO: { nome: "Atingido", tipo: "porcentagem" },
        MARGEM: { nome: "Margem", tipo: "porcentagem" },
      };
    },
  },

  watch: {
    'busca.dtfim'(newVal) {
      if (newVal < this.busca.dtinicio) {
        this.busca.dtinicio = newVal;
      }
    },

    'busca.dtinicio'(newVal) {
      if (this.busca.dtfim < newVal) {
        this.busca.dtfim = newVal;
      }
    },
  },

  methods: {
    // Formatadores
    formatarDinheiro(valor) {
      return this.$options.filters.formataDinheiro(valor || 0);
    },

    formatarPorcentagem(valor) {
      return `${valor || '0.00'} %`;
    },

    // Controle de tempo
    iniciarTimerAtualizacao() {
      // Limpa o timer anterior se existir
      if (this.intervalTimer) {
        clearInterval(this.intervalTimer);
      }

      // Registra o momento da atualização
      this.ultimaAtualizacao = new Date();
      this.tempoDecorrido = 0;

      // Atualiza o tempo decorrido a cada segundo
      this.intervalTimer = setInterval(() => {
        if (this.ultimaAtualizacao) {
          const agora = new Date();
          this.tempoDecorrido = Math.floor((agora - this.ultimaAtualizacao) / 1000);
        }
      }, 1000);
    },

    // Requisições API
    async fazerRequisicao(endpoint, params) {
      try {
        const { data } = await axios.post(`${this.backendUrl}${endpoint}`, params);
        return typeof data === 'string' ? JSON.parse(data) : data;
      } catch (error) {
        console.error(`Erro em ${endpoint}:`, error);
        return null;
      }
    },

    async carrega() {
      this.carregando = true;

      await Promise.all([
        this.listaVendasMaquinaVendas(),
        this.listaAcumuladoMaquinaVendas(),
        this.listaVendasEcommerce(),
        this.listaMetas()
      ]);

      this.carregando = false;

      // Inicia o contador de tempo após carregar os dados
      this.iniciarTimerAtualizacao();
    },

    async listaMetas() {
      const dados = await this.fazerRequisicao('dashboard/vendas/maquinadevendas/meta', {
        dtini: this.busca.dtinicio,
        dtfim: this.busca.dtfim,
      });

      if (dados) {
        this.metaMaquinaVendas = dados["9"]?.META || 0;
        this.metaEcommerce = dados["10"]?.META || 0;
      }
    },

    async listaVendasEcommerce() {
      const dados = await this.fazerRequisicao('dashboard/vendas/maquinadevendas', {
        dtini: this.busca.dtinicio,
        dtfim: this.busca.dtfim,
        iddepartamento: DEPARTAMENTO_ECOMMERCE,
      });

      this.totaisEcommerce = dados?.ECOMMERCE ? {
        TOTAL_VENDA: dados.ECOMMERCE.TOTAL_VENDA || 0,
        MARGEM: dados.ECOMMERCE.MARGEM || 0
      } : {};
    },

    async listaVendasMaquinaVendas() {
      const dados = await this.fazerRequisicao('dashboard/vendas/maquinadevendas', {
        dtini: this.busca.dtinicio,
        dtfim: this.busca.dtfim,
        iddepartamento: DEPARTAMENTO_MAQUINA_VENDAS,
      });

      if (dados?.MAQUINA_DE_VENDAS) {
        const vendedores = { ...dados.MAQUINA_DE_VENDAS };
        delete vendedores.TOTAL_VENDA;
        delete vendedores.MARGEM;

        this.vendedoresMaquinaVendas = Object.entries(vendedores).map(([id, dados]) => ({
          ID: id,
          ...dados
        }));

        this.atualizarDadosGrafico();
      } else {
        this.limparDadosGrafico();
      }
    },

    async listaAcumuladoMaquinaVendas() {
      const dados = await this.fazerRequisicao('dashboard/vendas/maquinadevendasacumualdo', {
        dtini: this.busca.dtinicio,
        dtfim: this.busca.dtfim,
        iddepartamento: DEPARTAMENTO_MAQUINA_VENDAS,
      });

      this.totaisMaquinaVendas = dados || {};
    },

    // Métodos auxiliares
    atualizarDadosGrafico() {
      this.dadosMeta = this.vendedoresMaquinaVendas.map(v => parseFloat(v.META));
      this.dadosRealizado = this.vendedoresMaquinaVendas.map(v => parseFloat(v.TOTALVENDA));
      this.dadosAtingimento = this.vendedoresMaquinaVendas.map(v => parseFloat(v.ATINGIMENTO));
      this.labelsNome = this.vendedoresMaquinaVendas.map(v => v.NOME.split(' ')[0]);
    },

    limparDadosGrafico() {
      this.vendedoresMaquinaVendas = [];
      this.dadosMeta = [];
      this.dadosRealizado = [];
      this.dadosAtingimento = [];
      this.labelsNome = [];
    },

    abrirDialog(dados, header, title) {
      this.dialog = { status: true, dados, header, title };
    },

    async init() {
      await this.carrega();
      this.carregandoInicial = false;
    },
  },

  created() {
    this.init();
  },

  beforeDestroy() {
    // Limpa o interval quando o componente for destruído
    if (this.intervalTimer) {
      clearInterval(this.intervalTimer);
    }
  },
};
</script>

<style scoped>
.dashboard-vendas {
  background: #f5f7fa;
  min-height: 100vh;
}

/* Card de Filtro */
.filter-card {
  border-radius: 12px;
  border: 1px solid #e0e0e0;
  overflow: hidden;
}

/* Seção Cards */
.section-card {
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.section-title {
  background: rgba(0, 0, 0, 0.1);
}

/* Animação dos Cards */
.card-animation {
  animation: fadeInUp 0.6s ease backwards;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Estado Vazio */
.empty-state {
  text-align: center;
  padding: 60px 20px;
}

/* Transições */
.v-fade-transition {
  transition: opacity 0.3s ease;
}

/* Responsivo */
@media (max-width: 600px) {
  .section-title {
    flex-direction: column;
    align-items: flex-start !important;
    gap: 12px;
  }
}
</style>